import Vue from 'vue'
import Vuex from 'vuex';
import { Toast } from 'mand-mobile'
import { getcwinfo, getsiteconfig, organization } from '@/request/api'


Vue.use(Vuex);
const store=new Vuex.Store({
  state: {
    userinfo: {},
    siteconfig: {}
  },
  getters: {
    
  },
  mutations: {
    updateuserinfo(state, val) {
      state.userinfo = val;
    },
    updatesiteconfig(state, val) {
      state.siteconfig = val;
    },
  },
  actions: {
    asyncupdateuserinfo(store) {
      return new Promise((resolve, reject) => {
        getcwinfo({}).then((res)=>{
          if(res.code === 200) {
            store.commit('updateuserinfo', res.data);
            resolve(res.data);
          } else if (res.code === 403) {
            Toast.failed("Login has expired, please login again");
            localStorage.removeItem("token");
          }
        }).catch(error => {
          reject(error)
        })
      });
    },
    asyncupdatesiteconfig(store) {
      return new Promise((resolve, reject) => {
        getsiteconfig({
          organization: organization
        }).then((res)=>{
          if(res.code === 200) {
            store.commit('updatesiteconfig', res.data);
            resolve(res.data);
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  modules: {
    
  }
});
export default store



// WEBPACK FOOTER //
// ./src/store/index.js